import React, {Component} from 'react';
import {app} from '../app';
import MyFrame from '../components/Frame';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Spin} from 'antd';
import IDetail from './insure/IDetail';
import IBuy from './insure/IBuy';
import IList from './insure/IList';
import IOrderList from './insure/IOrderList';
import '../css/insure.css';
import IZZZBuy from './insure/IZZZBuy';

function checkMenu(path) {
  let key = '1';
  switch (path) {
    case '/insure/zzzzr_buy':
      key = '2';
      break;
    case '/insure/orders':
      key = '3';
      break;
  }
  if (path.indexOf('/insure/details') !== -1 || path.indexOf('/insure/buy') !== -1) {
    key = '2';
  }
  return key;
}

class Insure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu_key: checkMenu(props.location.pathname),
      loading: false
    };
  }

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  async componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      await this.setData({menu_key: checkMenu(nextProps.location.pathname)});
    }
  }

  // 1国管;3督导官;10队长;11副队长;25报备队长;26文员;27报备队员
  render() {
    const isLogin = app.checkLogin();
    if (isLogin) {
      return (<Redirect to="/"/>);
    } else {
      let {menu_key, loading} = this.state;
      if (loading) {
        return (
          <div style={{textAlign: 'center', padding: '3rem 0'}}>
            <Spin size="large" tip="正在加载..."/>
          </div>
        );
      }
      let menuList = [
        {key: '1', text: '我的保险', link: '/insure/list'},
        {key: '2', text: '购买保险', link: '/insure/details'},
        {key: '3', text: '我的保险订单', link: '/insure/orders'}
      ];
      let nodeList = [
        (<Route path={menuList[0].link} key={'insure-route' + 1} component={IList}/>),
        (<Route path={menuList[1].link} key={'insure-route' + 2} component={IDetail}/>),
        (<Route path={menuList[2].link} key={'insure-route' + 3} component={IOrderList}/>),
        // (<Route path={menuList[2].link} key={'insure-route' + 3} component={IOrderList}/>),
        (<Route path="/insure/buy/:id" key={'insure-route' + 4} component={IBuy}/>),
        (<Route path="/insure/zzzzr_buy" key={'insure-route' + 5} component={IZZZBuy}/>),
      ];
      nodeList.push(
        <Route key={'insure-route' + nodeList.length} render={() => <Redirect to={menuList[0].link}/>}/>
      );
      return (
        <MyFrame className="insure-frame" history={this.props.history} menuList={menuList}
                 menuSelectKey={menu_key}>
          <Switch>{nodeList}</Switch>
        </MyFrame>
      );
    }
  }
}

export default Insure;



// WEBPACK FOOTER //
// ./src/routes/Insure.jsx